// extracted by mini-css-extract-plugin
module.exports = {"body":"_2vJhpK8yGAQUjt9-3ZN6rn","dialog":"_1MJ_Cp8qkrv_ZNAr6pYWw3","danger":"_2HBkLf3Z_Xt-gVRGPCyKLE"};